<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.newPassword"
        :validator="vs.form.newPassword"
        :error-messages="{
          minLength: $t(
            'passwordLengthErrorMessage',
            'Password must contain 5 characters at least',
          ),
        }"
        type="password"
        :label="$t('newPassword', 'New password')"
        autofocus
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.repeatPassword"
        :validator="vs.form.repeatPassword"
        :error-messages="{ sameAs: $t('passwordsDoNotMatchError', 'Passwords don\'t match') }"
        type="password"
        :label="$t('repeatPassword', 'Repeat password')"
      />
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'recover-password-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped></style>
